import React from 'react';

import { TCommonProps, TActionsProps, TInlineEditProps, TExportProps, TForwardedRef } from 'types/gridDefs';

import { AsDataGridActions } from './AsDataGridActions';
import { AsDataGridActionsRowEdit } from './AsDataGridActionsRowEdit';
import { AsDataGridCompact } from './AsDataGridCompact';
import { AsDataGridGroupNoCollapse } from './AsDataGridGroupNoCollapse';
import { AsDataGridGroup } from './AsDataGridGroup';
import { AsDataGridSimple } from './AsDataGridSimple';

/* ======================================== */

type TProps = TCommonProps & TActionsProps & TInlineEditProps & TExportProps;

/* ======================================== */

/**
 * Generaic DataGrid wrapper using "type" to select a specific type of DataGrid
 * !! prototype: still under development !!
 * @public
 */
const _AsDataGrid = React.forwardRef<TForwardedRef, TProps>((props, forwardedRef) => {
    switch (props.type) {
        case 'actions':
            return <AsDataGridActions {...props} ref={forwardedRef} />;
        case 'actionsRowEdit':
            return <AsDataGridActionsRowEdit {...props} ref={forwardedRef} />;
        case 'compact':
            return <AsDataGridCompact {...props} ref={forwardedRef} />;
        case 'groupNoCollapse':
            return <AsDataGridGroupNoCollapse {...props} ref={forwardedRef} />;
        case 'group':
            return <AsDataGridGroup {...props} ref={forwardedRef} />;
        case 'simple':
        default:
            return <AsDataGridSimple {...props} ref={forwardedRef} />;
    }
});

export const AsDataGrid = React.memo(_AsDataGrid);
